import { createRoute, Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { ApiError } from "../../shared/api/http.js";
import { Button, Card, Field, Input } from "../../shared/ui/index.js";
import { CenteredLayout } from "../../shared/ui/CenteredLayout.js";
import { useLogin } from "./auth.api.js";
import { rootRoute } from "../../app/root-route.js";

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginScreen,
});

function LoginScreen() {
  const navigate = useNavigate();
  const login = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  function submit(e: React.FormEvent) {
    e.preventDefault();
    login.mutate(
      { email, password },
      {
        onSuccess: ({ user }) =>
          navigate({
            to: user.mustChangePassword
              ? "/change-password"
              : user.role === "admin"
                ? "/admin"
                : "/app",
          }),
      },
    );
  }

  return (
    <CenteredLayout>
      <Card>
        <h1 className="text-center font-serif text-2xl text-stone-900">Connexion</h1>
        <p className="mt-1 text-center text-sm text-stone-500">Espace SmartVow</p>
        <form onSubmit={submit} className="mt-6 flex flex-col gap-3">
          <Field label="Email">
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </Field>
          <Field label="Mot de passe">
            <Input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>
          {login.error && (
            <p className="text-sm text-rose-600">
              {login.error instanceof ApiError ? login.error.message : "Erreur"}
            </p>
          )}
          <Button type="submit" disabled={login.isPending}>
            {login.isPending ? "…" : "Se connecter"}
          </Button>
          <Link
            to="/forgot-password"
            search={{ email: email || undefined }}
            className="text-center text-sm text-stone-500 underline-offset-2 hover:text-stone-800 hover:underline"
          >
            Mot de passe oublié ?
          </Link>
        </form>
      </Card>
    </CenteredLayout>
  );
}
